import React, { ChangeEvent } from "react";
import * as S from "./userAccountPageContent.style";
import { Button } from "../../atoms/Buttons";

interface UserAccountFindPageContentProps {
  onUserPasswordChangeHanlder: () => void;
  onUserBackPageMoveHanlder: () => void;
  register: any;
  setValue: any;
  isNext: boolean;
}

const UserAccountFindPageContent = ({
  onUserPasswordChangeHanlder,
  onUserBackPageMoveHanlder,
  register,
  setValue,
  isNext,
}: UserAccountFindPageContentProps) => {
  const handlePhoneNumberChange = (e: ChangeEvent<HTMLInputElement>) => {
    // 휴대폰 번호 입력시 자동으로 '-' 추가
    const phoneNumber = e.target.value.replace(/[^0-9]/g, "");
    let result = "";
    if (phoneNumber.length < 4) {
      result = phoneNumber;
    } else if (phoneNumber.length < 7) {
      result = phoneNumber.substring(0, 3) + "-" + phoneNumber.substring(3);
    } else if (phoneNumber.length < 11) {
      result =
        phoneNumber.substring(0, 3) +
        "-" +
        phoneNumber.substring(3, 6) +
        "-" +
        phoneNumber.substring(6);
    } else {
      result =
        phoneNumber.substring(0, 3) +
        "-" +
        phoneNumber.substring(3, 7) +
        "-" +
        phoneNumber.substring(7);
    }
    setValue("phoneNumber", result);
  };

  return (
    <S.UserAccountFindPageContentLayout>
      <div className="bodyContent">
        <S.UserAccountFindContentHeader>
          <S.ContentHeaderTop>
            <S.ContentHeaderTopStepBox>1 / 2 단계</S.ContentHeaderTopStepBox>
            <p>계정찾기</p>
          </S.ContentHeaderTop>
          <S.ContentHeaderBottom>
            <span>회원가입시 등록한 정보</span>를 <br /> 입력해주세요.
          </S.ContentHeaderBottom>
        </S.UserAccountFindContentHeader>
        <S.UserAccountFindContentBody>
          <label> 회원정보 입력 </label>
          <S.InputBox>
            <input type="text" {...register("username")} placeholder="이름" />
            <S.InputLabelText> 이름 </S.InputLabelText>
          </S.InputBox>
          <S.InputBox>
            <input
              type="text"
              {...register("phoneNumber")}
              maxLength={13}
              onChange={(e) => handlePhoneNumberChange(e)}
              placeholder="휴대폰번호"
            />
            <S.InputLabelText> 휴대폰번호 </S.InputLabelText>
          </S.InputBox>
        </S.UserAccountFindContentBody>
      </div>
      <div className="btnWrap">
        <div className="buttonBox">
          <div className="small">
            <Button
              type="button"
              size="full"
              color="transparent"
              label="이전"
              onClick={onUserBackPageMoveHanlder}
            />
          </div>
          <Button
            type="button"
            size="full"
            color="primary"
            label="다음"
            disabled={!isNext}
            onClick={onUserPasswordChangeHanlder}
          />
        </div>
      </div>
    </S.UserAccountFindPageContentLayout>
  );
};

export default UserAccountFindPageContent;
